<p-sidebar [(visible)]="toogle" position="left" styleClass="custom-sidebar" (visibleChange)="handleChangeToogle($event)"
    [baseZIndex]="10000">
    <ul class="h-full grid grid-rows-4 overflow-hidden">
        <li *ngFor="let item of items_sidebar"
            class="flex items-center justify-center {{ item.bg }} link-router cursor-pointer relative">
            <a *ngIf="item.path !== ''" routerLink="/{{ item.path }}" class="w-full" (click)="handleCloseToogle()"
                class="{{ item.bg }} flex items-center justify-center link-router cursor-pointer relative">
                <span class="text-white text-lg font-medium relative z-50">{{ item.name }}</span>
                <img src="{{ item.image }}" loading="lazy" decoding="async" class="absolute image w-full" alt="{{ item.image.split('/')[5]}}">
            </a>
            <a *ngIf="item.path === ''" [routerLink]="journeyRoutes.INFORMACION_PERSONAL" class="w-full" (click)="handleCloseToogle()"
                class="{{ item.bg }} flex items-center justify-center link-router cursor-pointer relative">
                <span class="text-white text-lg font-medium relative z-50">{{ item.name }}</span>
                <img src="{{ item.image }}" loading="lazy" decoding="async" class="absolute image w-full" alt="{{ item.image.split('/')[5]}}">
            </a>
        </li>
    </ul>
</p-sidebar>
